module.exports = __webpack_public_path__ + "static/media/tick.bec7a182.png";